<mat-form-field appearance="outline">
  @if (label) {
  <mat-label style="color: black">{{ label }}</mat-label>
  }
  <mat-select [formControl]="formControl" (selectionChange)="notify()" [disabled]="disabled" multiple>
    @for (option of optionArray; track identify($index, option)) {
    <mat-option value="{{ option.value }}">{{ option.label }}</mat-option>
    }
  </mat-select>
</mat-form-field>
